import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { categories } from '../categories';
import {Patient, SubCategory, Word} from '../_models';
import {Intercalaire} from '../_models/intercalaire';
import {CategoryService, IntercalaireService} from '../_services';
import {first} from 'rxjs/operators';
import {Category} from '../_models/category';
import {config} from '../../assets/config';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import * as cloneDeep from 'lodash/cloneDeep';
import {getCurrentAbeille, getCurrentRole} from '../../assets/utils.js';


@Component({
    selector: 'app-classeur',
    templateUrl: './classeur.component.html',
    styleUrls: ['./classeur.component.scss']
})

export class ClasseurComponent implements OnInit {

    @ViewChild('word', {static: false}) words: ElementRef[];

    ready = false;
    intercalaires: Intercalaire[] = [];
    categories = {};

    apiUrl = config.apiUrl;
    patientId = '';
    currentRole = '';
    currentIntercalaire = null;
    currentCategory = null;
    currentSubCategory = null;
    currentWord = null;
    currentPage = 0;
    intercalaireToEdit = null;
    wordToEdit: Word;
    wordsList = [];
    pages = {};
    showPages = false;
    currentSetPage = 0;
    processPages = false;
    checkedCategories = [];


    waitingForPageDisplay = false;

    showModalCreateWord = false;
    showModalCreateCategory = false;
    showModalEditCategory = false;
    showModalCreateIntercalaire = false;
    showModalShowWord = false;
    showModalMoveWord = false;
    showModalDeleteWord = false;

    editingMode = false;
    zoomMode = false;
    dragging = false;

    // turn page animations classes
    animClosePage = null;
    animOpenPageBegin = null;
    animOpenPageEnd = null;
    animInvertClosePage = null;
    animInvertOpenPageBegin = null;
    animInvertOpenPageEnd = null;

    constructor(private intercalaireService: IntercalaireService,
                private categoryService: CategoryService,
                private cd: ChangeDetectorRef) {

        this.patientId = getCurrentAbeille().id;
        this.currentRole = getCurrentRole();

        this.refreshIntercalairesList(null);
    }

    ngOnInit() {
    }

    refreshIntercalairesList(selectedIntercalaire: Intercalaire, selectedIntercalaireId?: string) {

        this.showModalCreateIntercalaire = false;

        this.intercalaireService.getByPatientId(this.patientId).pipe(first()).subscribe(intercalaires => {
            this.intercalaires = intercalaires as Intercalaire[];

            if (!this.intercalaires.length) {
                this.showModalCreateIntercalaire = true;

            } else {
                if (!selectedIntercalaire && !selectedIntercalaireId) {
                    this.currentIntercalaire = intercalaires[0] as Intercalaire;
                } else if (selectedIntercalaireId) {
                    this.currentIntercalaire = this.getIntercalaireById(selectedIntercalaireId);
                } else {
                    this.currentIntercalaire = selectedIntercalaire;
                }

                this.refreshCategoryList();
            }
        });

    }

    refreshCategoryList() {
        if (!this.currentIntercalaire) {
            return;
        }

        this.categoryService.getByIntercalaireId(this.currentIntercalaire.id).pipe(first()).subscribe(categories => {
            this.categories[this.currentIntercalaire.id] = categories as Category[];

            //If no category exists, we process the pages directly
            if (!this.categories[this.currentIntercalaire.id].length) {
                this.setUpPages();
            }

            this.categories[this.currentIntercalaire.id].map((item, index) => {
                this.categoryService.getByCategoryId(item.id).pipe(first()).subscribe(subCategories => {
                    item.subCategories = subCategories as SubCategory[];
                    if (index === this.categories[this.currentIntercalaire.id].length - 1) {
                        this.waitingForPageDisplay = true;

                        setTimeout(() => {
                            this.setUpPages();
                        }, 10);
                    }
                });
            });
        });


        this.showModalCreateCategory = false;
        this.showModalEditCategory = false;
        this.showModalCreateWord = false;
        this.showModalMoveWord = false;
        this.showModalDeleteWord = false;
    }

    selectIntercalaire(intercalaire) {
        this.currentIntercalaire = intercalaire;
        this.currentPage = 0;

        if (!this.categories[this.currentIntercalaire.id]) {
            this.refreshCategoryList();
        }
    }

    getIntercalaireById(id) {
        let found: Intercalaire = null;

        this.intercalaires.forEach(intercalaire => {

            if (intercalaire.id === id)
                found = intercalaire;
        });

        return found;
    }

    public addMot(category, type) {
        this.showModalCreateWord = true;
        this.currentCategory = null;
        this.currentSubCategory = null;
        this.wordToEdit = null;

        if (type === 'category') {
            this.currentCategory = category;
        }

        if (type === 'subCategory') {
            this.currentSubCategory = category;
        }
    }

    public editWord(word) {
        this.wordToEdit = word;
        this.showModalShowWord = false;
        this.showModalCreateWord = true;
    }

    public editIntercalaire(intercalaire) {
        this.showModalCreateIntercalaire = true;
        this.intercalaireToEdit = intercalaire;
    }

    public addCategory() {
        this.showModalCreateCategory = true;
        this.currentCategory = null;
        this.currentSubCategory = null;
    }

    public editCategory(category) {
        this.showModalEditCategory = true;
        this.currentCategory = category;
        this.currentSubCategory = null;
    }

    public addSubCategory(category) {
        this.showModalCreateCategory = true;
        this.currentCategory = category;
        this.currentSubCategory = null;
    }

    public editSubCategory(subCategory) {
        this.showModalEditCategory = true;
        this.currentCategory = null;
        this.currentSubCategory = subCategory;
    }

    public addIntercalaire() {
        this.intercalaireToEdit = null;
        this.showModalCreateIntercalaire = true;
    }

    /************
     * DRAG FUNCTIONS
     **********/
    onWordDragStarted(event: CdkDragEnd) {
        this.dragging = true;
    }

    onWordDragEnded(event: CdkDragEnd) {
        this.dragging = false;

        event.source.element.nativeElement.style.transform = 'none'; // visually reset element to its origin
        const source: any = event.source
        source._dragRef._passiveTransform = { x: 0, y: 0 };
    }

    /**********
     * SHOW WORD FUNCTIONS
     *********/
    showWordDetails(intercalaire, category, subCategory, word) {
        this.currentSubCategory = subCategory;
        this.currentCategory = category;
        this.currentWord = word;
        this.showModalShowWord = true;
    }

    /***********
    * MOVE WORD FUNCTIONS
    ***********/
    showMoveWord(word) {
      this.currentWord = word;
      this.showModalMoveWord = true;
    }

    /***********
    * DELETE WORD FUNCTIONS
    ***********/
    showDeleteWord(word) {
      this.currentWord = word;
      this.showModalDeleteWord = true;
    }



    setUpPages() {
        this.pages[this.currentIntercalaire.id] = []
        this.pages[this.currentIntercalaire.id].push({
            intercalaire: this.currentIntercalaire,
            categories: this.categories[this.currentIntercalaire.id],
            categoriesComplete: []
        });


        if (this.processPages) {
            return;
        }

        this.processPages = true;
        this.currentSetPage = 0;

        this.showPages = true;
        setTimeout(() => this.setUpPage(), 100);
    }

    setUpPage() {

        if (!this.processPages) {
            return;
        }

        if (this.pages[this.currentIntercalaire.id] && !this.pages[this.currentIntercalaire.id][(this.currentSetPage + 1)]) {
            const clone = cloneDeep(this.pages[this.currentIntercalaire.id][this.currentSetPage]);
            this.pages[this.currentIntercalaire.id].push(clone);

            console.log("CLONE");
            console.log(clone);
        }

        let result = document.getElementsByClassName("page-container");
        if (!result[0]) {
            this.waitingForPageDisplay = true;
            this.cd.markForCheck();
            return;
        }
        let maxPos = result[0].getBoundingClientRect().top + (result[0] as any).offsetHeight - 30;
        console.log('PAGE ' + this.currentSetPage);
        let results = document.getElementsByClassName("page-container")[this.currentSetPage].getElementsByClassName("word");
        console.log('has '+ results.length + 'words');

        if (!results.length) {
            this.removeWordUntilIndex(this.currentSetPage+1, 0);
        }

        for (let i = 0; i < results.length; i++) {
            let item = results[i];

            //console.log('--------- ');
            //console.log('item ' + i);
            let name = item.getElementsByClassName("title")[0].textContent;
            //console.log('name ' + name);
            //console.log('current offset ' + item.getBoundingClientRect().top + (item as any).offsetHeight  + " : " + maxPos);
            if (item.getBoundingClientRect().top + (item as any).offsetHeight <= maxPos) {

                //console.log('fits ! ');
                if (i === results.length - 1) {
                    //console.log('last one !! ');
                    //let res = document.getElementsByClassName("page-container")[3].getElementsByClassName("word").length;
                    this.removeWordUntilIndex(this.currentSetPage + 1, i + 1);
                    this.removeWordAfterIndex(this.currentSetPage + 1, 0);
                    this.processPages = false;

                    this.pages[this.currentIntercalaire.id].pop();

                    if (this.currentSetPage % 2 === 0) {
                        //this.pages[this.currentIntercalaire.id].push([]);
                    }

                    //res = document.getElementsByClassName("page-container")[3].getElementsByClassName("word").length;
                }
            } else {
                //console.log('doesnt fit ! ');

                this.removeWordAfterIndex(this.currentSetPage, i);

                //if last item we delete every on next page
                if (i === results.length - 1) {
                    //console.log('last one !! ');
                    this.removeWordUntilIndex(this.currentSetPage + 1, i );
                    this.processPages = false;

                    if (this.currentSetPage % 2 === 1) {
                        this.removeWordAfterIndex(this.currentSetPage + 2, 0);
                    }

                }

                this.removeWordUntilIndex(this.currentSetPage + 1, i);
                this.cd.markForCheck(); // marks path

                break;
            }
        }

        if (!results.length && this.currentSetPage === 0) {
            this.processPages = false;
            this.pages[this.currentIntercalaire.id].pop();
            return;
        }

        this.currentSetPage++;
        this.waitingForPageDisplay = true;

    }

    ngAfterViewChecked() {

        setTimeout(() => this.ready = true, 600);

        if (this.waitingForPageDisplay) {
            this.waitingForPageDisplay = false;
            setTimeout(() => this.setUpPage(), 40);
        }
    }

    removeWordAfterIndex(page, index) {

        //console.log('   -- REMOVE PAGE ' + page + ' AFTER index ' + index);

        let categories = this.pages[this.currentIntercalaire.id][page]['categories'];
        let intercalaireWords = this.pages[this.currentIntercalaire.id][page]['intercalaire'].words;
        let wordsList = [];
        let currIndex = 0;
        let categoriesToDelete = [];

        categories.forEach((category, i) => {
            let subCategories = (category as Category).subCategories;

            for (let j = 0; j < subCategories.length; j++) {
                let words = subCategories[j].words;
                let nbWords = words.length;
                let startDel = -1;
                let qtyDel = 0;

                for (let k = 0; k < words.length; k++) {
                    if (currIndex >= index) {
                        if (startDel < 0) {
                            startDel = k;
                        }
                        qtyDel++;
                    }
                    currIndex++;
                }

                if (startDel >= 0) {
                    category.subCategories[j].words.splice(startDel, qtyDel);
                }

                //console.log("                    qtyDel "+qtyDel+" nbWords "+nbWords+" sub length "+category.subCategories.length);
                if (qtyDel > 0 && qtyDel === nbWords) {
                    category.subCategories.splice(j, 1);
                }
            }

            let words = categories[i].words;
            let nbWords = words.length;
            let startDel = -1;
            let qtyDel = 0;

            for (let k = 0; k < words.length; k++) {
                if (currIndex >= index) {
                    if (startDel < 0) {
                        startDel = k;
                    }
                    qtyDel++;
                }
                currIndex++;
            }

            if (startDel >= 0) {
                categories[i].words.splice(startDel, qtyDel);
            }

            //console.log("                    qtyDel "+qtyDel+" nbWords "+nbWords+" sub length "+category.subCategories.length);
            if (qtyDel > 0 && qtyDel === nbWords && !category.subCategories.length) {
                //console.log("                !!delete "+i);
                categoriesToDelete.push(i);
            }
        });

        for (let l = 0; l < categoriesToDelete.length; l++) {
            categories.splice(categoriesToDelete[l] - l, 1);
        }

        let nbWords = intercalaireWords.length;
        let startDel = -1;
        let qtyDel = 0;

        for (let k = 0; k < intercalaireWords.length; k++) {
            if (currIndex >= index) {
                if (startDel < 0) {
                    startDel = k;
                }
                qtyDel++;
            }
            currIndex++;
        }

        if (startDel >= 0) {
            intercalaireWords.splice(startDel, qtyDel);
        }

    }

    removeWordUntilIndex(page, index) {

        //console.log('   -- REMOVE PAGE ' + page + ' UNTIL index ' + index);
        let categories = this.pages[this.currentIntercalaire.id][page]['categories'];
        let currIndex = 0;
        let qtyDelTotal = 0;
        let categoriesToDelete = [];

        categories.forEach((category, i) => {
            this.checkedCategories.push(category.id);

            //console.log("       -- check category "+ (category as Category).name);
            let subCategories = (category as Category).subCategories;
            let nbSubCategories = subCategories.length;
            let subCategoriesToDelete = [];

            for (let j = 0; j < nbSubCategories; j++) {
                this.checkedCategories.push(subCategories[j].id);
                //console.log("            -- check subcategory "+ subCategories[j].name);
                let words = cloneDeep(subCategories[j].words);
                let initialNbWords = words.length;
                let nbWords = words.length;
                let qtyDel = 0;

                //console.log("                contains " + nbWords + ' words');

                words.forEach((word, k) => {
                    //console.log("                -----");
                    //console.log("                check word " + (word as Word).name);
                    //console.log("                index " + currIndex + " :: " + index);

                    if (currIndex < index) {
                        //console.log("                A SUPPR " +(k - qtyDel));

                        //console.log("                ---------");
                        //console.log("                words current");
                        let dpc = cloneDeep(subCategories[j].words);
                        //console.log(dpc);
                        subCategories[j].words.splice(k - qtyDel, 1);
                        //console.log("                words after");
                        let dpc2 = cloneDeep(subCategories[j].words);
                        //console.log(dpc2);
                        qtyDel++;
                        qtyDelTotal++;
                    } else {
                        //console.log("                ok...");
                    }
                    currIndex++;
                });

                if (qtyDel > 0 && qtyDel === nbWords) {
                    subCategoriesToDelete.push(j);
                    this.pages[this.currentIntercalaire.id][page - 1].categoriesComplete.push(category.subCategories[j].id);
                }

                if (!nbWords && this.checkedCategories.indexOf(subCategories[j].id) !== -1) {
                    subCategoriesToDelete.push(j);
                    this.pages[this.currentIntercalaire.id][page - 1].categoriesComplete.push(category.subCategories[j].id);
                }
            }


            for (let l = 0; l < subCategoriesToDelete.length; l++) {
                subCategories.splice(subCategoriesToDelete[l] - l, 1);
            }


            let words = cloneDeep(category.words);
            let nbWords = words.length;
            let qtyDel = 0;

            words.forEach((word, k) => {
                //console.log("                -----");
                //console.log("                check word " + (word as Word).name);
                //console.log("                index " + currIndex + " :: " + index);

                if (currIndex < index) {
                    //console.log("                A SUPPR " +k);
                    //console.log("                ---------");
                    //console.log("                words current");
                    let dpc = cloneDeep(category.words);
                    //console.log(dpc);
                    categories[i].words.splice(k - qtyDel, 1);
                    //console.log("                words after");
                    let dpc2 = cloneDeep(category.words);
                    //console.log(dpc2);
                    qtyDel++;
                    qtyDelTotal++;
                } else {
                    //console.log("                ok...");
                }
                currIndex++;
            });

            //console.log("                --- END WORDS");
            //console.log("                    qtyDel "+qtyDel+" nbWords "+nbWords+" sub length "+category.subCategories.length);

            if (qtyDel > 0 && qtyDel === nbWords && !category.subCategories.length) {
                //console.log("                !!delete "+i);
                categoriesToDelete.push(i);
                this.pages[this.currentIntercalaire.id][page - 1].categoriesComplete.push(category.id);
            }

            if (!nbWords && !category.subCategories.length && this.checkedCategories.indexOf(category.id) !== -1) {
                //console.log("                !!delete "+i);
                categoriesToDelete.push(i)

                this.pages[this.currentIntercalaire.id][page - 1].categoriesComplete.push(category.id);
            }
        });

        for (let l = 0; l < categoriesToDelete.length; l++) {
            categories.splice(categoriesToDelete[l] - l, 1);
        }

        let intercalaireWords = cloneDeep(this.pages[this.currentIntercalaire.id][page]['intercalaire'].words);
        let nbWords = intercalaireWords.length;
        let qtyDel = 0;

        for (let k = 0; k < intercalaireWords.length; k++) {

            //console.log("YOO");
            if (currIndex < index) {
                this.pages[this.currentIntercalaire.id][page]['intercalaire'].words.splice(k - qtyDel, 1);
                qtyDel++;
            } else {
                //console.log("                ok...");
            }
            currIndex++;
        }

    }

    goPrevPage() {

        this.animInvertClosePage = this.currentPage;
        this.animInvertOpenPageBegin = this.currentPage - 1;
        setTimeout(() => this.animInvertOpenPageEnd = this.currentPage - 1, 250);
        setTimeout(() => {
            this.currentPage -= 2;
            this.animInvertClosePage = null;
            this.animInvertOpenPageBegin = null;
            this.animInvertOpenPageEnd = null;
        }, 500);
    }

    goNextPage() {

        this.animClosePage = this.currentPage + 1;
        this.animOpenPageBegin = this.currentPage + 2;
        setTimeout(() => this.animOpenPageEnd = this.currentPage + 2, 250);
        setTimeout(() => {
            this.currentPage += 2;
            this.animClosePage = null;
            this.animOpenPageBegin = null;
            this.animOpenPageEnd = null;
        }, 500);
    }
}
